export const EditionInitialValues = (localeCodes, showData) => ({
  code: showData?.data?.code || "",
  localizations: localeCodes.reduce((acc, localeCode) => {
    acc[localeCode] = showData?.data?.localization_contents?.[localeCode] ?? "";
    return acc;
  }, {}),
});
